import { useEffect, useState } from "react";
import classes from "../../styles/popupModal.module.css";
import { Box, Modal, Typography, useMediaQuery } from "@mui/material";
import { useTranslation } from "react-i18next";
import CloseIcon from "@mui/icons-material/Close";
import RegistrationBtn from "../pujaRegistration/registrationBtn";
import { useDispatch } from "react-redux";
import { addSubEventDetails } from "@utils/reduxToolkit/features/subEventSlice";
import { useRouter } from "next/router";
import { deleteRegistrationDetails } from "@utils/reduxToolkit/features/registrationDetailsSlice";
import { deleteCart } from "@utils/reduxToolkit/features/cartSlice";
import { trackEvent } from "@utils/analytics/event-analytics";
import { LANGUAGE, WEB_ENGAGE } from "@utils/constants";
import { useCookies } from "react-cookie";
// import watchVideo from "../../../../public/watch_puja.mp4";

function PopupModal({
  deityName,
  subEventsCategory,
  templeName,
  eventName,
  eventName_WE,
  eventUrlExtension,
  openModal,
  setOpenModal,
  EventFestivalTimelines,
  dummyRegistration
}) {
  const {
    t
  } = useTranslation();
  const dispatch = useDispatch();
  const router = useRouter();
  // const { state } = useContext(Store);
  // const loggedInUser = state.user;

  const bigScreen = useMediaQuery("(min-width:768px)");

  // const [openModal, setOpenModal] = useState(false);
  const [selectedSubEventIdx, setSelectedSubEventIdx] = useState(0);
  const [selectedSubEventAmount, setSelectedSubEventAmount] = useState(0);
  const [seatNo, setSeatNo] = useState(0);
  const [cookies, setCookie, removeCookie] = useCookies(["seatNo"]);
  const [btnLoader, setBtnLoader] = useState(false);
  const handleCloseModal = () => {
    setOpenModal(false);
    trackEvent(WEB_ENGAGE.SCREEN_NAMES.EVENT_DETAILS_POPUP + " " + WEB_ENGAGE.EVENT_NAMES.DIALOG_CLOSED, {
      [WEB_ENGAGE.EVENT_PROPERTIES.SCREEN_NAME]: WEB_ENGAGE.SCREEN_NAMES.EVENT_DETAILS,
      [WEB_ENGAGE.EVENT_PROPERTIES.KRIYA_NAME]: eventName_WE || "Unknown Kriya",
      [WEB_ENGAGE.EVENT_PROPERTIES.EVENT_URL_EXTENSION]: eventUrlExtension
    });
  };
  const generateRandomSeatNo = () => {
    let storedSeatNo = 0;
    if (cookies.seatNo && parseInt(cookies.seatNo) > 0) {
      storedSeatNo = parseInt(cookies.seatNo, 10);
    } else {
      const randomSeatNo = Math.floor(Math.random() * (30 - 4 + 1)) + 4;
      setCookie("seatNo", randomSeatNo, {
        path: "/",
        maxAge: 60 * 60
      });
      storedSeatNo = randomSeatNo;
    }
    setSeatNo(storedSeatNo);
  };
  useEffect(() => {
    trackEvent(WEB_ENGAGE.SCREEN_NAMES.EVENT_DETAILS_POPUP + " " + WEB_ENGAGE.EVENT_NAMES.DIALOG_VIEWED, {
      [WEB_ENGAGE.EVENT_PROPERTIES.SCREEN_NAME]: WEB_ENGAGE.SCREEN_NAMES.EVENT_DETAILS,
      [WEB_ENGAGE.EVENT_PROPERTIES.KRIYA_NAME]: eventName_WE || "Unknown Kriya",
      [WEB_ENGAGE.EVENT_PROPERTIES.EVENT_URL_EXTENSION]: eventUrlExtension
    });
    generateRandomSeatNo();
    // const seatNo = useMemo(generateRandomSeatNo, []);
    // setSeatNo(seatNo);
  }, []);
  useEffect(() => {
    if (subEventsCategory.length > 0) {
      let index = 0;
      let mostOfferedFound = false;
      // const randomIndex = Math.floor(Math.random() * subEventsCategory.length);
      for (let item of subEventsCategory) {
        if (item.isMostOffered) {
          setSelectedSubEventIdx(index);
          setSelectedSubEventAmount(subEventsCategory[index].eventRegistrationAmount);
          mostOfferedFound = true;
          break;
        }
        index++;
      }
      if (!mostOfferedFound && subEventsCategory.length > 0) {
        setSelectedSubEventIdx(0);
        setSelectedSubEventAmount(subEventsCategory[0].eventRegistrationAmount);
      }
    }
  }, [subEventsCategory]);
  const redirectedUrl = () => {
    setBtnLoader(true);
    const selectedSubEvent = subEventsCategory[selectedSubEventIdx];
    trackEvent(WEB_ENGAGE.SCREEN_NAMES.EVENT_DETAILS_POPUP + " " + WEB_ENGAGE.BUTTON_NAMES.DIALOG_BOOK + " " + WEB_ENGAGE.EVENT_NAMES.BUTTON_CLICKED, {
      [WEB_ENGAGE.EVENT_PROPERTIES.SCREEN_NAME]: WEB_ENGAGE.SCREEN_NAMES.EVENT_DETAILS,
      [WEB_ENGAGE.EVENT_PROPERTIES.BUTTON_NAME]: WEB_ENGAGE.BUTTON_NAMES.SUB_KRIYA_BOOK,
      [WEB_ENGAGE.EVENT_PROPERTIES.KRIYA_NAME]: eventName_WE,
      [WEB_ENGAGE.EVENT_PROPERTIES.SUB_KRIYA_NAME]: selectedSubEvent.name_WE,
      [WEB_ENGAGE.EVENT_PROPERTIES.AMOUNT]: Number(selectedSubEvent.eventRegistrationAmount),
      [WEB_ENGAGE.EVENT_PROPERTIES.EVENT_DEITY_TYPE]: deityName,
      [WEB_ENGAGE.EVENT_PROPERTIES.EVENT_URL_EXTENSION]: eventUrlExtension
    });
    const subEventObj = {
      ...selectedSubEvent,
      templeName,
      eventName,
      eventName_WE,
      referrerID: null,
      contact: null,
      notes: null,
      language: router.locale,
      deityName: deityName,
      festivalName: EventFestivalTimelines.length > 0 ? EventFestivalTimelines[0].FestivalTimeline.title : null
    };
    dispatch(addSubEventDetails(subEventObj));
    dispatch(deleteRegistrationDetails());
    dispatch(deleteCart());
    // sessionStorage.removeItem("previousRoute");

    if (bigScreen) {
      router.push(`/puja/registration/${eventUrlExtension}/${selectedSubEvent.urlExtension}`, undefined, {
        locale: router.locale
      });
      return;
    }
    setBtnLoader(false);
    dummyRegistration(subEventObj);
    setOpenModal(false);
  };
  return <Modal open={openModal} onClose={handleCloseModal} data-sentry-element="Modal" data-sentry-component="PopupModal" data-sentry-source-file="popupModal.jsx">
      <Box className={classes.container} data-sentry-element="Box" data-sentry-source-file="popupModal.jsx">
        <div>
          <div className={classes.headerContainer}>
            <Typography className={classes.heading} data-sentry-element="Typography" data-sentry-source-file="popupModal.jsx">
              {t("offer-your-puja-to")} {deityName ?? ""} {t("today")}.
            </Typography>
            <CloseIcon onClick={handleCloseModal} data-sentry-element="CloseIcon" data-sentry-source-file="popupModal.jsx" />
          </div>
          <div className={classes.remainingSeatsContainer}>
            <Typography className={classes.remainingSeats} data-sentry-element="Typography" data-sentry-source-file="popupModal.jsx">
              {t("only")} {seatNo} {t("seats-in-this-slot")}
            </Typography>
          </div>
        </div>

        {/* <div className={classes.videoContainer}>
          <video
            width="100%"
            controls={false}
            muted
            loop
            autoPlay={true}
            controlsList="nofullscreen"
          >
            <source
              src={
                router.locale === LANGUAGE.ENGLISH
                  ? "/watch_puja_en.mp4"
                  : "/watch_puja_hi.mp4"
              }
              type="video/mp4"
            />
          </video>
         </div> */}

        <div className={classes.videoContainer}>
          <video width="100%" controls={false} muted loop autoPlay playsInline controlsList="nofullscreen">
            <source src={router.locale === LANGUAGE.ENGLISH ? "/watch_puja_en.mp4" : "/watch_puja_hi.mp4"} type="video/mp4" />
          </video>
          {/* <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              cursor: "default",
            }}
           ></div> */}
        </div>

        <Typography className={classes.participateText} data-sentry-element="Typography" data-sentry-source-file="popupModal.jsx">
          {t("participate-in-puja-0")}
        </Typography>

        <div className={classes.recommendedContainer}>
          {subEventsCategory.length > 0 && subEventsCategory?.slice(0, 3).map((item, idx) => <div key={idx} className={selectedSubEventIdx === idx ? classes.recommendedItemSelected : classes.recommendedItem} onClick={() => {
          setSelectedSubEventIdx(idx);
          setSelectedSubEventAmount(item.eventRegistrationAmount);
        }}>
                <Typography className={classes.typeText}>
                  {item.maxOfferingName === "1" ? t("single") : item.maxOfferingName === "2" ? t("partner") : t("family")}
                </Typography>
                <Typography sx={{
            fontSize: "12px"
          }}>
                  {item.maxOfferingName}
                  {item.maxOfferingName == "1" ? " " + t("Devotee") : " " + t("Devotees")}
                </Typography>
                <Typography sx={{
            fontWeight: "bold",
            color: "#FF5757",
            fontFamily: "Poppins",
            fontSize: "18px",
            mt: "2px"
          }}>
                  ₹ {item.eventRegistrationAmount}
                </Typography>
                {item.isMostOffered && <div className={classes.mostOfferedContainer}>
                    <Typography sx={{
              fontSize: "12px",
              fontWeight: "bold"
            }}>
                      {" "}
                      {t("most-offered-0")}
                    </Typography>
                  </div>}
              </div>)}
        </div>

        <RegistrationBtn btnText={`${t("offer-your-puja-at")} ₹ ` + selectedSubEventAmount} setProps={redirectedUrl} animation={true} loading={btnLoader} data-sentry-element="RegistrationBtn" data-sentry-source-file="popupModal.jsx" />
      </Box>
    </Modal>;
}
export default PopupModal;